<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                <v-row align="center">
                    <v-col cols="4">
                        Κατηγορίες
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                            v-model="search"
                            :loading="loading"
                            :search-input.sync="search"
                            menu-props="auto"
                            label="Αναζήτηση Κατηγοριών"
                            prepend-inner-icon="mdi-magnify"
                            hide-details
                            clearable
                            return-object
                        />
                    </v-col>
                    <v-col cols="4" align="end">
                        <v-btn v-if="$store.getters.getRole === 'ADMIN'" class="my-2 mr-2" dark small color="black" @click="createCategory">
                            <v-icon dark>mdi-plus</v-icon>Καταχώριση
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-card>
        <array-view
            :items="categories"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            @handleClick="handleClick"
            @paginationChange="paginationChange"
            @onDelete="onDelete"
        />
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import categoryService from '@/services/category'
    import ArrayView from '@/components/ArrayView'
    import Alert from '@/components/Alert'

    export default {
        name: 'Category',
        components: { ArrayView, Alert },
        data: () => {
            return {
                loading: false,
                successfullImport: null,
                categories: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Τίτλος',
                        value: 'title'
                    },
                    {
                        text: 'Κωδικός',
                        value: 'code'
                    },
                    {
                        text: 'Κατηγορία πατέρας',
                        value: 'parent',
                        subLevel: 'title'
                    }
                ],
                search: null,
                showImportDialog: false,
                size: 5,
                totalPages: 0,
                page: 1,
                showAlert: false,
                message: null,
                type: null
            }
        },
        watch: {
            search() {
                if (this.search) {
                    this.fetchFilteredCategories()
                } else {
                    this.fetchAllCategories()
                }
            },
            page() {
                var path = `/categories?page=${this.page}&size=${this.size}`
                if (this.$route.fullPath !== path) {
                    this.$router.push(path)
                }
            },
            size() {
                var path = `/categories?page=${this.page}&size=${this.size}`
                if (this.$route.fullPath !== path) {
                    this.$router.push(path)
                }
            }
        },
        created() {
            this.page = this.$route.query.page ? parseInt(this.$route.query.page) : 1
            this.fetchAllCategories()
        },
        methods: {
            fetchFilteredCategories() {
                this.loading = true
                categoryService.getFilteredCategories(this.search, this.page, this.size).then(resp => {
                    this.categories = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.loading = false
                })
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            paginationChange(page, size) {
                this.size = size
                this.page = page
                if (this.search) {
                    this.fetchFilteredCategories()
                } else {
                    this.fetchAllCategories()
                }
            },
            handleClick(action, item) {
                this.$router.push(`/categories/${item.id}/${action}?page=${this.page}&size=${this.size}`)
            },
            createCategory() {
                this.$router.push(`/categories/create?page=${this.page}&size=${this.size}`)
            },
            fetchAllCategories() {
                categoryService.getCategories(this.page, this.size).then(resp => {
                    this.categories = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            onDelete(category) {
                categoryService.deleteCategory(category.id)
                    .then(() => this.$router.go())
                    .catch((error) => {
                        this.setAlert(error.response.data.message, 'error')
                    })
            }
        }
    }
</script>

<style scoped>

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
